/**
 * Renders a CMS-overridable image without flashing (or downloading) the stock
 * fallback first. While `loading` is true, or there is no `src` yet, it renders
 * a same-sized neutral placeholder with no image URL, so the browser fetches
 * nothing and the layout does not shift. Once the CMS data is known, it
 * renders the real <img>.
 */
export default function CmsImage({ src, alt = "", loading = false, className = "", testId, ...imgProps }) {
  if (loading || !src) {
    return (
      <div
        aria-hidden="true"
        data-testid={testId ? `${testId}-placeholder` : undefined}
        data-cms-loading="true"
        className={`${className} bg-slate-100 animate-pulse`}
      />
    );
  }
  return <img src={src} alt={alt} data-testid={testId} className={className} decoding="async" {...imgProps} />;
}
